import React from 'react'
import {
  Divider, Steps, Row, Col, Input, Select, Pagination, DatePicker,
  Button, Table, Popconfirm, TreeSelect, Affix, message,
  BackTop, Spin, Tabs,
  InputNumber
} from 'antd'
import common from '@/public/common'
import './index.less'
import { withRouter } from 'react-router-dom'
import { ajaxApi, netExport, netApi, netApiNo } from '@/server'
import { summation, getCookie, getCookieNew, getParmUrl, outformat } from '../../public/utils'
import moment from 'moment'
import { cloneDeep, find, get, set, sumBy, trim } from 'lodash'
const { Step } = Steps
const { TabPane } = Tabs
const host = window.location.host
const urlLink = common.oldScs + '/scs'

class OrderDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDropshipping:false, // 是否是一件代发订单
      sping: false,
      data: [],
      sumData: {},
      pageNo: 0,
      pageSize: 15,
      total: 0,
      info: [],
      search: {}
    }
  }
  componentDidMount() {
    this.getDetails(true)
  }
  // 查询订单详情
  getDetails = (isGetList) => {
    let param = {
      PROID: getParmUrl('PROID')
    }
    netApiNo({
      url: urlLink + '/ReturnPurchase',
      action: 'getpurchasereturninfo',
      params: param
    }).then(res => {
      if (res.data.error_code === 0) {
        this.setState({
          // isDropshipping:true,
          info: res.data.data
        },()=>{
          if(isGetList){
            this.getList()
          }
        })
      } else {
        message.error(res.data.error_message)
      }
    })
  }
  // 获取列表信息
  getList = () => {
    let {isDropshipping} = this.state
    this.setState({
      sping: true
    })
    let param = {
      ...this.state.search,
      PROID: getParmUrl('PROID')
    }
    netApiNo({ // 获取数据总数 0.0
      url: urlLink + '/ReturnPurchase',
      action: 'getporeturndetailsum',
      params: param
    }).then(res => {
      if (res.data.error_code === 0) {
        this.setState({
          total: res.data.data
        })
      } else {
        message.error(res.data.error_message)
      }
    })
    let params = {
      url: urlLink + '/ReturnPurchase',
      action: 'getporeturndetail',
      pageIndex: this.state.pageNo,
      pageSize: this.state.pageSize,
      params: param
    }
    netApi(params).then((res) => {
      if (res.data.error_code === 0) {
        let data = typeof (res.data.data) === 'string' ? [] : res.data.data
        this.setState({
          originData:cloneDeep(data),
          data:data,
          sumData: res.data.sumdata,
          sping: false
        })
      } else {
        message.error(res.data.error_message)
      }
    })
  }
  // 搜索条件input框值更改
  inputChange = (name, val) => {
    let _obj = this.state.search
    _obj[name] = val.target.value
    this.setState({
      search: _obj
    })
  }
  // 搜索
  search = () => {
    let {isDropshipping} = this.state
    if (isDropshipping) {
      // 如果是一件代发的订单，这边的搜索需要自己实现，不走接口
      this.searchByLocal()
    } else {
      this.setState({
        pageNo: 0,
        pageSize: 15
      }, () => {
        this.getList()
      })
    }
  }

  searchByLocal = () => {
    let { search, originData,sumData } = this.state
    let ProductCode = trim(get(search, "ProductCode") || "")
    let ProductName = trim(get(search, "ProductName") || "")
    let res = []
    if (ProductCode && ProductName) {
      originData.forEach(item => {
        if (item.ProductCode == ProductCode && item.ProductName == ProductName) {
          res.push(item)
        }
      })
    } else if (ProductCode || ProductName) {
      originData.forEach(item => {
        if (item.ProductCode == ProductCode || item.ProductName == ProductName) {
          res.push(item)
        }
      })
    } else {
      res = cloneDeep(originData)
    }
    sumData.SumQty = sumBy((res||[]),function(o) { return o.Quantity; })||0
    sumData.SumPrice = sumBy((res||[]),function(o) { return o.SumPOPrice; })||0
    this.setState({
      data: res,
      sumData,
    })
  }
  reset = () => {
    this.setState({
      search: {
        TimeCategory: 'audittime',
        BeginTime: moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
        EndTime: moment(new Date()).format('YYYY-MM-DD')
      }
    }, () => {
      this.getList()
    })
  }
  // 跳转单据详情/编辑单据
  goDetails = (type, code) => {
    if (type === 'edit') {
      window.open('http://' + host + '/main/supplierRecantion/addSend?code=' + code)
    } else {
      window.open('http://' + host + '/main/supplierRecantion/sendDetails?code=' + code)
    }
  }
  // 表格分页
  pageOnChange = (val) => {
    this.setState({
      pageNo: val - 1
    }, () => {
      this.getList()
    })
  }
  sizeOnchange = (current, size) => {
    this.setState({
      pageNo: current - 1,
      pageSize: size
    }, () => {
      this.getList()
    })
  }
  // 确认收货
  receive = () => {
    let { isDropshipping } = this.state
    if (isDropshipping) {
      this.isDropshippingReceive()
    }else{
      netApiNo({
        url: urlLink + '/ReturnPurchase',
        action: 'updateporeturnstatusforsupplier',
        params: { PROID: getParmUrl('PROID') }
      }).then(res => {
        if (res.data.error_code === 0) {
          message.success('收货成功')
          setTimeout(() => {
            window.location.reload()
          }, 800)
        } else {
          message.error(res.data.error_message)
        }
      })
    }
  }

  isDropshippingReceive = () => {
    /**
    * 判断是否是一件代发，
    * 如果是一件代发，那合格数量和不合格数量必填一项，否则不作要求
    * 有分页，可能要取消分页
    */
    let { originData,search } = this.state
    let flag = true
    for (let index = 0; index < originData.length; index++) {
      const element = originData[index];
      if (["null", "undefined"].includes(String(element.qualifiedQuantity)) && ["null", "undefined"].includes(String(element.unqualifiedQuantity))) {
        flag = false
      }
    }
    if (!flag) {
      search.ProductCode = ""
      search.ProductName = ""
      this.setState({
        search,
      },()=>{
        this.searchByLocal()
      })
      message.warn("一件代发的订单，需填写合格数量或不合格数量！")
      return
    }
    let params = {
      return_code:getParmUrl("code"),
      details:originData.map(item =>{
        return {
          product_code:item.ProductCode,
          quantity:item.Quantity,
        }
      })
    }
    ajaxApi({
      url:common.escmApiUrl+"bolon/receive-in-stock",
      params:params
    })
  }

  // 导出
  export = () => {
    netExport({
      url: urlLink + '/Export',
      action: 'getreturndetailexport',
      filename: '投诉详情.xls',
      params: { PROID: getParmUrl('PROID') }
    }).then(res => {

    })
  }

  iptNumChange = (id, type, value) => {
    let { originData,data } = this.state
    let target = find((originData || []), { ProductCode: id, })
    let target2 = find((data || []), { ProductCode: id, })
    set(target, type, value)
    set(target2, type, value)
    this.setState({
      originData:cloneDeep(originData),
      data: cloneDeep(data)
    })
  }

  render() {
    const { data, sumData, total, sping, search, statusList, typeList, info,isDropshipping } = this.state
    const columns = [
      {
        title: '货品编码',
        dataIndex: 'ProductCode',
        align: 'left'
      },
      {
        title: '货品名称',
        align: 'left',
        dataIndex: 'ProductName',
        width: 200,
      },
      {
        title: '退货数量',
        align: 'left',
        dataIndex: 'Quantity'
      },
      // {
      //   title: '合格数量',
      //   align: 'left',
      //   dataIndex: 'qualifiedQuantity',
      //   render: (text, record) => {
      //     //  对于一件代发的，合格数量和不合格数量必须要填一个，其他情况的订单不做要求
      //     return <InputNumber max={record.Quantity-(record.unqualifiedQuantity||0)} onChange={this.iptNumChange.bind(this, record.ProductCode, "qualifiedQuantity")} value={record.qualifiedQuantity} placeholder='请输入' min={0} />
      //   }
      // },
      // {
      //   title: '不合格数量',
      //   align: 'left',
      //   dataIndex: 'unqualifiedQuantity',
      //   render: (text, record) => {
      //     return <InputNumber max={record.Quantity-(record.qualifiedQuantity||0)} onChange={this.iptNumChange.bind(this, record.ProductCode, "unqualifiedQuantity")} value={record.unqualifiedQuantity} placeholder='请输入' min={0} />
      //   }
      // },
      {
        title: '单价',
        dataIndex: 'POPrice',
        align: 'center',
        width: '15%',
        render: (text) => (
          <span>{outformat(text.toFixed(2))}</span>
        )
      },
      {
        title: '币种',
        dataIndex: 'MoneyType',
        align: 'center',
        width: '15%',
        render: (text) => (
          <span>{text || '-'}</span>
        )
      },
      {
        title: '金额',
        dataIndex: 'SumPOPrice',
        align: 'right',
        render: (text) => (
          <span>{outformat(text.toFixed(2))}</span>
        )
      }
    ]
    return (
      <div className="returnList">
        <Spin spinning={sping}>
          <Affix offsetTop={10}>
            <div className="search">
              <div style={{ width: '60%', marginLeft: '20%' }}>
                <Steps progressDot current={info.length > 0 ? info[0].StatusForSupplier === '已完成' ? 3
                  : info[0].StatusForSupplier === '视客已退货，待收货' ? 2 : info[0].StatusForSupplier === '视客已退货，待收货' ? 1 : 0 : 0}>
                  <Step title="待视客退货" />
                  <Step title="视客退货" />
                  <Step title="供应商确认收货" />
                  <Step title="完成" />
                </Steps>
              </div>
            </div>
          </Affix>
          <div className="returnBody">
            <h2 style={{ fontSize: '20px' }}><span style={{ fontWeight: 'bold' }}>订单状态：</span><span>{info.length > 0 ? info[0].StatusForSupplier : ''}</span>&nbsp;<span style={{ fontWeight: 'bold', marginLeft: '10px' }}>退货单号：</span><span>{getParmUrl('code')}</span>
              <Button type="primary" shape="round" style={{ display: info.length > 0 ? info[0].StatusForSupplier === '视客已退货，待收货' ? 'inline-block' : 'none' : 'none', marginLeft: '25px' }} onClick={this.receive}>
                {isDropshipping?"一件代发确认收货":"确认收货"}
              </Button>
            </h2>
            <Tabs type="card">
              <TabPane tab="货品详情" key="1">
                <p>货品编码：<Input style={{ width: '200px', marginRight: '25px' }} onChange={this.inputChange.bind(this, 'ProductCode')} placeholder="请输入" />货品名称：<Input style={{ width: '200px', marginRight: '25px' }} onChange={this.inputChange.bind(this, 'ProductName')} placeholder="请输入" /><Button type="primary" shape="round" onClick={this.search}>查询</Button></p>
                <p style={{ display: getParmUrl('return') ? 'block' : 'none' }}><Button shape="round" onClick={this.export}>导出</Button></p>
                <p><span>总退货数量：{sumData ? sumData.SumQty : ''}</span><span style={{ marginLeft: '10px' }}>金额：{sumData ? sumData.SumPrice : ''}</span></p>
                <Table columns={columns} dataSource={data} pagination={false} rowKey={record => record.PROID} />
                {
                  !isDropshipping && (
                    <div className="pagination">
                      <span className="datanum">{'共' + total + '条数据'}</span>
                      <Pagination showQuickJumper showSizeChanger current={(this.state.pageNo) + 1} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                    </div>
                  )
                }
              </TabPane>
              <TabPane tab="物流信息" key="2">
                <p>发货地址：江苏省南京市江宁区湖熟镇波光路30号，视客眼镜网，4007168432</p>
                <p>收货地址：{info.length > 0 ? info[0].ReceivingAddress : ''}</p>
                <Tabs type="card">
                  <TabPane tab="包裹1"></TabPane>
                </Tabs>
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      </div>
    )
  }
}
export default OrderDetails



// WEBPACK FOOTER //
// ./src/pages/returnGoods/orderDetails.js